module.exports = __webpack_public_path__ + "img/ic_statistic.f01cdef.svg";